
import { colors, spacing } from '../../../style/theme';
import { staticImageUrl } from '../../../util/images';
import Flex from '../../UI/Flex';
import { Headings, Paragraph } from '../../UI/TextStyles';

export const teamMembers = {
  Path: {
    name: 'Path Wei',
    email: 'pathwei@wren.co',
    image: 'team/wren-path-wei-3-square.jpg',
    hours: 'Central European Time',
  },
  Landon: {
    name: 'Landon',
    email: 'landon@wren.co',
    image: 'team/wren-landon-brand.jpg',
    hours: 'Pacific Time',
  },
  Christina: {
    name: 'Christina',
    email: 'christina@wren.co',
    image: 'christina-beckman.jpeg',
    hours: 'Pacific Time',
  },
};

export function ContactCallout({
  title,
  member,
  customCTA,
}: {
  title?: string;
  member?: keyof typeof teamMembers;
  customCTA?: string;
}) {
  const contactMember = member ? teamMembers[member] : teamMembers['Path'];

  return (
    <Flex
      direction="row"
      wrap
      justify="center"
      align="baseline"
      gap={spacing.massive}
    >
      <Flex
        direction="column"
        align="center"
        justify="center"
        css={{
          maxWidth: 600,
          backgroundColor: 'rgba(244, 246, 250, 1)',
          padding: `${spacing.large}px ${spacing.xLarge}px`,
          boxSizing: 'border-box',
          borderRadius: 30,
        }}
        id="contact"
      >
        <Paragraph css={{ fontWeight: 600, color: colors.wrenGreen }}>
          Talk to a
        </Paragraph>
        <Headings.Large
          font="serif"
          css={{
            marginBottom: spacing.default,
            fontStyle: 'italic',
            textAlign: 'center',
          }}
        >
          Wren team member
        </Headings.Large>

        <Paragraph
          css={{
            textAlign: 'center',
            color: colors.textSecondary,
            marginBottom: spacing.medium,
          }}
        >
          {customCTA ? (
            customCTA
          ) : title ? (
            <>
              If you have specific questions about <i>{title.trim()}</i>, our
              team is here to help answer them.
            </>
          ) : (
            'Have specific questions or requests? Our team is here to help answer them.'
          )}
        </Paragraph>
        <div css={{ marginBottom: spacing.large }}>
          <Flex direction="row" align="center" gap={spacing.small}>
            <img
              src={staticImageUrl(contactMember.image, {
                w: 150,
              })}
              width={54}
              height={54}
              alt={`${contactMember.name}, Wren team member`}
              css={{ borderRadius: '50%', objectFit: 'cover' }}
            />
            <div>
              <Paragraph
                css={{
                  fontWeight: 600,
                  fontSize: 16,
                  marginBottom: spacing.tiny,
                }}
              >
                Questions?
              </Paragraph>
              <a
                href={`mailto:${contactMember.email}`}
                css={{
                  fontWeight: 400,
                  color: colors.wrenGreen,
                  lineHeight: '140%',
                }}
              >
                Email {contactMember.name}
              </a>
            </div>
          </Flex>
        </div>

        <Paragraph css={{ color: colors.textSecondary, fontSize: 12 }}>
          {contactMember.hours} business hours.
        </Paragraph>
      </Flex>
    </Flex>
  );
}
